import { format } from 'date-fns';

import { translate } from 'hooks/useTranslate';
import { Board, Council } from 'types';

import attendanceTypes from 'constants/attendanceTypes';
import { DATE_FORMAT_WITH_TIME_ALT } from 'constants/defaultConstants';

import BoardBadge from '../../BoardBadge';
import { getVisibilityData } from '../../RecentBoardsSection/hooks/useGetVisibility';

type GetCardItemsProps = {
  board: Board | Council | undefined;
  status: {
    statusLabel: string;
    statusBadge: string;
    statusValue: string;
    statusIcon: string;
  };
};

export const getCardItems = ({ board, status }: GetCardItemsProps) => {
  if (!board) return [];

  const {
    name = '-',
    date,
    place = '-',
    attendanceType,
    lastModifiedDate,
    comments = '-',
  } = board as Board;

  const formattedDate = date
    ? format(new Date(date), DATE_FORMAT_WITH_TIME_ALT)
    : '-';

  const formattedLastModifiedDate = lastModifiedDate
    ? format(new Date(lastModifiedDate), DATE_FORMAT_WITH_TIME_ALT)
    : formattedDate;

  const { visibilityLabel, visibilityBadge } = getVisibilityData(board);

  return [
    { title: 'Name', value: name },
    { title: 'Date', value: formattedDate },
    {
      title: 'Status',
      value: (
        <BoardBadge
          badge={status.statusBadge}
          text={status.statusLabel}
          icon={status.statusIcon}
        />
      ),
    },
    {
      title: 'Visibility',
      value: (
        <span className={`badge badge-dot badge-${visibilityBadge}`}>
          {translate(visibilityLabel)}
        </span>
      ),
    },
    { title: 'Place', value: place },
    {
      title: 'FormOfAssistance',
      value: attendanceTypes?.[attendanceType]?.label || '-',
      valueNeedsTranslation: true,
    },
    { title: 'LastModification', value: formattedLastModifiedDate },
    { title: 'CommentsLabel', value: comments },
  ];
};
